import { Box, Button, Chip, FormControlLabel, Switch, Typography } from '@mui/material';
import { PageSelectionControlsProps } from './PDFPageSelectionControls.props';
import { PDFPageSelectionControlsContainer } from './PDFPageSelectionControls.styles';

const PDFPageSelectionControls = ({
  allowPageSelection,
  isPopped,
  selectedPages,
  onToggleSelectionMode,
  onPageToggle,
  onClearSelection,
  onProcessPages,
  genJobProcessing,
}: PageSelectionControlsProps) => (
  <PDFPageSelectionControlsContainer $allowPageSelection={allowPageSelection} $isPopped={isPopped}>
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', width: '100%' }}>
      <FormControlLabel
        control={
          <Switch
            checked={allowPageSelection}
            onChange={e => onToggleSelectionMode(e.target.checked)}
            color="primary"
          />
        }
        label="Enable Page Selection"
      />
    </Box>

    {allowPageSelection && (
      <>
        <Typography variant="body2" color="text.secondary">
          {selectedPages.size} page{selectedPages.size === 1 ? '' : 's'} selected
        </Typography>

        {selectedPages.size > 0 && (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {Array.from(selectedPages)
              .sort((a, b) => a - b)
              .map(pageNum => (
                <Chip
                  key={pageNum}
                  label={`Page ${pageNum}`}
                  size="small"
                  color="primary"
                  onDelete={() => onPageToggle(pageNum)}
                  disabled={genJobProcessing}
                />
              ))}
          </Box>
        )}

        <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
          {selectedPages.size > 0 && (
            <>
              <Button variant="outlined" size="small" onClick={onClearSelection} disabled={genJobProcessing}>
                Clear Selection
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={onProcessPages}
                color="primary"
                disabled={genJobProcessing}>
                {genJobProcessing ? 'Processing...' : 'Extract Tables from Selected Pages'}
              </Button>
            </>
          )}
        </Box>
      </>
    )}
  </PDFPageSelectionControlsContainer>
);

export default PDFPageSelectionControls;
